module.exports = __webpack_public_path__ + "static/media/linkedin.94db7e92.png";